<template>
  <div>
    <CTabs
      :vertical="vertical"
      :variant="variant"
      add-nav-wrapper-classes="website-tabs"
      @update:activeTab="handleActiveTab"
    >
      <!-- Products -->
      <CTab>
        <template slot="title">
          Produtos
        </template>

        <CRow class="mt-4">
          <CCol col="12">
            <h5 class="mb-4">
              <b>Produtos</b>
            </h5>
          </CCol>

          <CCol
            col="12"
            sm="6"
          >
            <div class="d-flex align-items-center">
              <label
                for="product-whatsapp-status"
                class="mb-0 mr-1"
              >Exibir Whatsapp</label>
              <CSwitch
                id="product-whatsapp-status"
                class="mx-1"
                color="success"
                variant="3d"
                v-bind="labelIcon"
                :checked="form.whatsapp_products_status === '1' ? true : false"
                @update:checked="setWhattsappProducts($event)"
              />
            </div>
          </CCol>
        </CRow>

        <CRow class="mt-4">
          <CCol lg="6">
            <div
              role="group"
              class="form-group"
            >
              <label for="whatsapp_products"> Whatsapp </label>
              <input
                id="whatsapp_products"
                v-model="form.whatsapp_products"
                v-mask="whatsappProducts"
                type="tel"
                label="Whatsapp"
                placeholder="(00) 00000-0000"
                class="form-control"
              />
            </div>
          </CCol>
        </CRow>
      </CTab>

      <!-- Contacts -->
      <CTab>
        <template slot="title">
          Localização / Contatos
        </template>

        <CRow class="mt-4">
          <CCol col="12">
            <h5 class="mb-4">
              <b>Localização / Contatos</b>
            </h5>
          </CCol>

          <CCol
            col="12"
            lg="6"
          >
            <CInput
              v-model="form.address"
              label="Endereço"
            />
          </CCol>

          <CCol
            col="12"
            lg="6"
          >
            <CInput
              v-model="form.map"
              label="Localização / Mapa"
              placeholder=""
              description="Google Maps Iframe"
            />
          </CCol>

          <CCol
            col="12"
            lg="6"
          >
            <div
              role="group"
              class="form-group"
            >
              <label for="phone"> Telefone</label>
              <input
                id="whatsapp_products"
                v-model="form.phone"
                type="tel"
                label="Telefone"
                placeholder="(00) 00000-0000"
                class="form-control"
              />
            </div>
          </CCol>

          <CCol
            col="12"
            lg="6"
          >
            <div
              role="group"
              class="form-group"
            >
              <label for="contact_whatsapp"> Whatsapp</label>
              <input
                id="whatsapp_products"
                v-model="form.contact_whatsapp"
                v-mask="contact_whatsapp"
                type="tel"
                label="Whatsapp"
                placeholder="(00) 00000-0000"
                class="form-control"
              />
            </div>
          </CCol>
        </CRow>
      </CTab>

      <!-- Social Media -->
      <CTab>
        <template slot="title">
          Redes Sociais
        </template>

        <CRow class="mt-4 mb-4">
          <CCol col="12">
            <h5 class="mb-4">
              <b>Redes Sociais</b>
            </h5>
          </CCol>

          <CCol
            col="12"
            lg="6"
          >
            <CInput
              v-model="form.twitter"
              type="text"
              placeholder="Digite o link para o Twitter"
            >
              <template #prepend>
                <CButton class="btn-twitter">
                  <CIcon
                    name="cib-twitter"
                    height="14"
                  />
                </CButton>
              </template>
            </CInput>
          </CCol>

          <!-- Facebook -->
          <CCol
            col="12"
            lg="6"
          >
            <CInput
              v-model="form.facebook"
              type="text"
              placeholder="Digite o link para o Facebook"
            >
              <template #prepend>
                <CButton class="btn-facebook">
                  <CIcon
                    name="cib-facebook"
                    height="14"
                  />
                </CButton>
              </template>
            </CInput>
          </CCol>

          <!-- Instagram -->
          <CCol
            col="12"
            lg="6"
          >
            <CInput
              v-model="form.instagram"
              type="text"
              placeholder="Digite o link para o Instagram"
            >
              <template #prepend>
                <CButton class="btn-instagram">
                  <CIcon
                    name="cib-instagram"
                    height="14"
                  />
                </CButton>
              </template>
            </CInput>
          </CCol>

          <!-- Youtube -->
          <CCol
            col="12"
            lg="6"
          >
            <CInput
              v-model="form.youtube"
              type="text"
              placeholder="Digite o link para o Youtube"
            >
              <template #prepend>
                <CButton class="btn-youtube">
                  <CIcon
                    name="cib-youtube"
                    height="14"
                  />
                </CButton>
              </template>
            </CInput>
          </CCol>

          <!-- LinkedIn -->
          <CCol
            col="12"
            lg="6"
          >
            <CInput
              v-model="form.linkedin"
              type="text"
              placeholder="Digite o link para o LinkedIn"
            >
              <template #prepend>
                <CButton class="btn-linkedin">
                  <CIcon
                    name="cib-linkedin"
                    height="14"
                  />
                </CButton>
              </template>
            </CInput>
          </CCol>
        </CRow>
      </CTab>

      <!-- Google -->
      <CTab>
        <template slot="title">
          Aplicativos de Terceiros
        </template>

        <CRow class="mt-4 mb-4">
          <CCol col="12">
            <h5 class="mb-4">
              <b>Aplicativos de Terceiros</b>
            </h5>
          </CCol>

          <CCol
            col="12"
            sm="6"
          >
            <div class="d-flex align-items-center">
              <label
                for="scripts"
                class="mb-0 mr-1"
              >Ativar scripts</label>
              <CSwitch
                id="scripts"
                class="mx-1"
                color="success"
                variant="3d"
                v-bind="labelIcon"
                :checked="form.scripts === '1' ? true : false"
                @update:checked="setScript($event)"
              />
            </div>
          </CCol>
        </CRow>

        <CRow class="mt-4 mb-4">
          <CCol
            col="12"
            sm="6"
          >
            <CInput
              v-model="form.google_site_verification"
              label="Google Site Verification"
              placeholder="Ex: DYHYmfhZQ41R0uRhPPSVw3kzfWyC36eM6XJqaLuYQkg"
              :description="`Insira a key de verificação gerada para indexação do domínio.`"
            />
          </CCol>
          <CCol
            col="12"
            sm="6"
          >
            <CInput
              v-model="form.google_analytics_id"
              label="Google Analytics"
              placeholder="Ex: UA-XXXXXX"
              :description="`Insira o código gerado pelo Google Analytics.`"
            />
          </CCol>
          <CCol
            col="12"
            sm="6"
          >
            <CInput
              v-model="form.google_tag_manager"
              label="Google Tag Manager"
              placeholder="Ex: GTM-XXXXXX"
              :description="`Insira o código gerado pelo Google Tag Manager.`"
            />
          </CCol>
        </CRow>
      </CTab>

      <!-- Enviroment -->
      <CTab>
        <template slot="title">
          Ambiente
        </template>

        <CRow class="mt-4 mb-4">
          <CCol col="12">
            <h5 class="mb-4">
              <b>Ambiente</b>
            </h5>
          </CCol>

          <CCol
            col="12"
            class="d-flex align-items-center"
          >
            <div class="d-flex align-items-center mr-4">
              <label
                for="homolog"
                class="mb-0 mr-1"
              >Homologação</label>
              <CSwitch
                id="homolog"
                name="environment"
                value="homolog"
                type="radio"
                class="mx-1"
                color="success"
                variant="3d"
                v-bind="labelIcon"
                :checked="form.environment === 'homolog'"
                @update:checked="setEnvironment"
              />
            </div>
            <div class="d-flex align-items-center mr-4">
              <label
                for="production"
                class="mb-0 mr-1"
              >Produção</label>
              <CSwitch
                id="production"
                name="environment"
                value="production"
                type="radio"
                class="mx-1"
                color="success"
                variant="3d"
                v-bind="labelIcon"
                :checked="form.environment === 'production'"
                @update:checked="setEnvironment"
              />
            </div>
          </CCol>

          <CCol col="12">
            <h5 class="mb-4 mt-4">
              <b>Status</b>
            </h5>
          </CCol>

          <CCol
            col="12"
            class="d-flex align-items-center"
          >
            <div class="d-flex align-items-center">
              <label
                for="maintenance"
                class="mb-0 mr-1"
              >Manutenção</label>
              <CSwitch
                id="maintenance"
                class="mx-1"
                color="success"
                variant="3d"
                v-bind="labelIcon"
                :checked="
                  form.environment_under_maintenance === '1' ? true : false
                "
                @update:checked="setEnvironmentStatus($event)"
              />
            </div>
          </CCol>
        </CRow>
      </CTab>
    </CTabs>

    <!-- Actions -->
    <CRow v-if="activeTabIndex !== cmsTabIndex">
      <CCol
        lg="12"
        class="d-flex justify-content-end align-items-center mt-2"
      >
        <a
          href="javascript:void(0)"
          class="mr-3"
          @click="resetForm"
        >Limpar Alterações</a>
        <CButton
          color="success"
          :disabled="processing"
          @click="send"
        >
          {{ processing ? 'Salvando...' : 'Salvar' }}
        </CButton>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'
import SettingsService from '@/services/settings.service'

export default {
  data() {
    return {
      vertical: false,
      variant: 'tabs',
      labelIcon: {
        labelOn: '\u2713',
        labelOff: '\u2715'
      },
      settings: {
        // Products
        whatsapp_products_status: 1,
        whatsapp_products: '',

        // Address/Contacts
        address: '',
        phone: '',
        contact_whatsapp: '',
        map: '',

        // Social Networks
        twitter: '',
        facebook: '',
        youtube: '',
        linkedin: '',
        instagram: '',

        // Scripts
        scripts: true,
        google_site_verification: '',
        google_tag_manager: '',
        google_analytics_id: '',

        // Enviroment
        environment: 'homolog',
        environment_under_maintenance: false,

        // Privacy
        // terms_of_user: '',
        // terms_of_use_link: '',
        // privacy_policy: '',
        // privacy_policy_link: '',
        acceptance_text: ''
      },
      form: {},
      processing: false,
      positions: [
        {
          position: 'left',
          label: 'Esquerda'
        },
        // {
        //   position: 'right',
        //   label: 'Direita'
        // },
        // {
        //   position: 'center',
        //   label: 'Centro'
        // },
        {
          position: 'top',
          label: 'Topo'
        },
        {
          position: 'bottom',
          label: 'Embaixo'
        }
      ],
      controllers: [
        {
          position: 'none',
          label: 'Sem controlador'
        },
        {
          position: 'left',
          label: 'Esquerda'
        },
        {
          position: 'right',
          label: 'Direita'
        }
      ],
      selectedImg: 'positions/previews/left',
      activeTabIndex: 0,
      cmsTabIndex: 7
    }
  },

  computed: {
    whatsappProducts() {
      if (
        this.form.whatsapp_products &&
        this.form.whatsapp_products.length > 14
      ) {
        return '+55 (##) #####-####'
      } else {
        return '+55 (##) ####-####?#'
      }
    },
    // phone() {
    //   if (this.form.phone && this.form.phone.length > 14) {
    //     return '+55 (##) #####-####'
    //   } else {
    //     return '+55 (##) ####-####?#'
    //   }
    // },
    contact_whatsapp() {
      if (
        this.form.contact_whatsapp &&
        this.form.contact_whatsapp.length > 14
      ) {
        return '+55 (##) #####-####'
      } else {
        return '+55 (##) ####-####?#'
      }
    }
  },

  created() {
    this.handlerWindowSize()
    this.getSettings()
  },

  methods: {
    selectPosition(position) {
      this.selectedImg = `positions/previews/${position}`
      this.form.cookies_notification_position = position
    },

    selectController(position) {
      this.selectedImg = `controllers/previews/${position}`
      this.form.cookies_notification_controller = position
    },

    setEnvironment(checked, event) {
      this.form.environment = event.target.value
    },

    setEnvironmentStatus(checked) {
      this.form.environment_under_maintenance = checked
    },

    setWhattsappProducts(checked) {
      this.form.whatsapp_products_status = checked
    },

    setScript(checked, event) {
      this.form.scripts = checked
    },

    setCookiesNotification(checked) {
      this.form.cookies_notification = checked

      if (
        this.form.cookies_notification &&
        this.form.cookies_notification_text === ''
      ) {
        this.setDefaultCookiesNotificationText()
      }
    },

    setDefaultCookiesNotificationText() {
      this.form.cookies_notification_text =
        'Nós usamos cookies e outras tecnologias semelhantes para melhorar a sua experiência em nossos serviços. Ao utilizar nossos serviços, você concorda com tal monitoramento.'
    },

    async getSettings() {
      const data = await SettingsService.listAll()

      this.form = cloneDeep(data)
      this.settings = cloneDeep(data)

      if (this.form.cookies_notification_position) {
        this.selectPosition(this.form.cookies_notification_position)
      }
    },

    resetForm() {
      this.form = cloneDeep(this.settings)
    },

    async send() {
      this.processing = true

      if (this.form.cookies_notification_text === '') {
        this.setDefaultCookiesNotificationText()
      }

      const data = this.form

      const response = await SettingsService.setSettings(data)

      if (response.status === 200) {
        this.$notify({
          group: 'notifications',
          type: 'success',
          text: 'Configurações salvas com sucesso'
        })
      } else {
        this.$notify({
          group: 'notifications',
          type: 'error',
          text: 'Erro ao salvar as configurações, tente novamente mais tarde.'
        })
      }

      this.processing = false
    },

    handleActiveTab(index) {
      this.activeTabIndex = index
    },

    /**
     * Verify and sets alignment of tabs component
     */
    handlerWindowSize() {
      const handler = () => {
        if (window.innerWidth <= 992) {
          this.variant = 'pills'
        } else {
          this.variant = 'tabs'
        }
      }

      window.addEventListener('resize', () => {
        handler()
      })

      handler()
    }
  }
}
</script>

<style lang="scss">
.website-tabs {
  .nav {
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    flex-wrap: nowrap;

    .nav-item {
      a {
        white-space: nowrap;
      }
    }
  }
}

.informative {
  display: block;
  margin-top: 10px;
  padding: 15px 20px;
  background: #e1f3f8;
  border-radius: 0.25rem;
}

.span_description {
  color: #768192;
  margin-top: 0.25rem;
}

.preview-image {
  transform: translateX(-4%);

  img {
    width: 100%;
  }
}

.preview-select {
  display: flex;

  div {
    margin: 0px 10px;
    cursor: pointer;

    &:first-child {
      margin-left: 0px;
    }

    &:last-child {
      margin-right: 0px;
    }

    img {
      border: 2px solid $secondary-600;
    }

    &.active {
      img {
        border-color: $success;
      }
    }
  }
}
</style>
